<template lang="pug">
  v-card
    v-toolbar.elevation-0(height="45" color="gray")
      v-toolbar-title(style="width: 100%;")
        v-layout.pa-0.ma-0(row)
          h1.subheading {{ $t('pageHeader.userActivity') }}
          v-spacer          
          h1.subheading {{ activitys.length }}
    v-card-text.list-500
      v-layout(column)
        template(v-for="(row, index) in activitys")
          v-layout.pointer(column @click="openLink(row)")
            v-flex.pb-0
              v-layout
                v-flex.font-weight-medium.green--text {{ row.userName }}
                v-spacer
                v-flex.caption.text-xs-right(color="text--gray") {{ row.date | moment("from", "now") }}                  
            v-flex.pt-0
              span.caption.list-line {{ row.to }}
          v-divider(v-if="index + 1 < activitys.length" :key="index")
</template>

<script>

export default {
  data() {
    return {
      activitys: [],
    }
  },
  sockets: {
    routerChange(data){
      // console.log('routerChange', data)
      if (this.activitys.length !== 0) {
        let index = this.activitys.findIndex(x => x.userID === data.userID)
        // console.log('index', index)
        if (index !== -1) {
          this.activitys.splice(index, 1)
        }
        this.activitys.unshift(data)
        // console.log('index', index)
      }else {
        this.activitys.push(data)
      }
      localStorage.setItem(`${process.env.VUE_APP_STORAGE_PREFIX}userActivity`, JSON.stringify(this.activitys))
    }
  },
  created() {        
    let activity = localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}userActivity`)
    if (activity) {
      this.activitys = JSON.parse(activity)
    }
  },
  methods: {
    openLink(data) {
      // console.log(data, process.env.VUE_APP_FE_URL)
      this.$router.push({ path: `${data.to}` })
      // window.open(`${process.env.VUE_APP_FE_URL}${data.to}`, '_blank');
    }
  }
}
</script>

<style scoped>
</style>